import type { CustomerFacingRouteId } from "@/lib/navigation-routes";

export const customerFeatureDocs: Record<CustomerFacingRouteId, string> = {
  account_home: "account-home",
  repositories: "manage-repositories",
  upload_archive: "upload-archives",
  fleet_agents: "fleet-agents",
  inspection_history: "inspection-history",
  waste_index: "engineering-waste-index",
  sdlc_findings: "sdlc-findings",
  dependency_tracker: "dependency-tracker",
  feedback_analysis: "feedback-analysis",
  standards_and_tastes: "standards-and-tastes",
  preference_engine: "preference-engine",
  suppressed: "suppressed-recommendations",
  agent_health: "agent-health",
  agents_md_builder: "agents-md-builder",
  docs: "getting-started",
  estate_setup: "estates-and-fleets",
  access: "add-users",
  providers: "connect-providers",
  subscriptions: "subscriptions",
  api_tokens: "api-tokens",
  user_settings: "user-settings",
  notifications: "notifications",
  admin: "admin-dashboard",
  admin_tasks: "admin-dashboard",
  admin_catalog: "admin-dashboard",
  cli: "cli-guide",
};

export const docsRoutes = [
  ["account-home", "Home"],
  ["getting-started", "Getting started"],
  ["navigation-and-search", "Navigate the app"],
  ["scope-bar", "Scope switcher"],
  ["estates-and-fleets", "Estates and Fleets"],
  ["estate-map", "Estate Map"],
  ["resources-fleet", "Unassigned Fleet"],
  ["fleet-overview", "Fleet Overview guide"],
  ["fleet-agents", "Fleet Agents"],
  ["connect-providers", "Connect GitHub or GitLab"],
  ["manage-repositories", "Manage repositories"],
  ["upload-archives", "Upload a repository archive"],
  ["run-inspection", "Run an inspection"],
  ["understand-results", "Understand inspection results"],
  ["inspection-history", "Inspection history"],
  ["sdlc-findings", "SDLC Findings guide"],
  ["agent-markdown", "Download agent Markdown"],
  ["engineering-waste-index", "Engineering Waste Index"],
  ["ninety-day-plan", "90-Day Plan"],
  ["maintenance-tasks", "Maintenance tasks"],
  ["maintenance-plan", "Maintenance Plan"],
  ["campaigns", "Campaigns"],
  ["dependency-tracker", "Dependency Tracker guide"],
  ["dependency-graph", "The Graph and upgrade decisions"],
  ["feedback-analysis", "Feedback Analysis"],
  ["commit-intelligence", "Commit Intelligence"],
  ["standards-and-tastes", "Standards and Tastes guide"],
  ["preference-engine", "Tastes guide"],
  ["suppressed-recommendations", "Suppressed recommendations"],
  ["agents-md-builder", "AGENTS.md Builder"],
  ["agent-health", "Agent Health"],
  ["roles", "Roles"],
  ["add-users", "Add users to an Estate"],
  ["security-and-access", "Security and access"],
  ["user-settings", "User Settings"],
  ["api-tokens", "API tokens"],
  ["notifications", "Notifications"],
  ["pr-reviews", "PR reviews"],
  ["subscriptions", "Subscriptions"],
  ["cli-guide", "CLI guide"],
  ["cli-reference", "CLI command reference"],
  ["cli-automation", "Automate with the CLI"],
  ["admin-dashboard", "Platform Admin Dashboard"],
  ["troubleshooting", "Troubleshooting"],
  ["glossary", "Glossary"],
] as const;
